import { DrawCard } from "../../../components/DrawCard/DrawCard";
import { FC } from "react";
import { IDraw } from "../DrawItem";

interface IDrawCardPassiveProps {
    draw: IDraw;
}

export const DrawCardPassive: FC<IDrawCardPassiveProps> = ({ draw }) => {
    return <DrawCard draw={ draw } />
};

